import { ReactElement } from 'react';

import { Box } from '@mui/material';

import { StyledContentLayout } from '@/components';

import {
  Billing,
  Invoices,
  Subscriptions as SubscriptionsSection,
  SubscriptionsSnackbar,
} from '../components';

export const Subscriptions = (): ReactElement => {
  return (
    <Box bgcolor="#FFF" height="100%">
      <StyledContentLayout fixedHeight>
        <Billing />
        <SubscriptionsSection />
        <Invoices />
        <SubscriptionsSnackbar />
      </StyledContentLayout>
    </Box>
  );
};
